<template>
  <div class="footprint">
    <div class="collect">
      <header v-if="!empty">
        <p v-if="!editor" @click="editorClick()">编辑</p>
        <p v-else-if="editor" @click="editorClick()">取消</p>
        <p v-if="!editor" @click="clearClick">清空</p>
      </header>
      <!--<scroller :on-infinite="infinite" :on-refresh="refresh" :noDataText="noDataText" ref="my_scroller">-->
      <Scroller
        v-if="list && list.length > 0"
        :is-refresh-data.sync="refresh"
        :is-loading-data.sync="loading"
        :is-finished-data.sync="finished"
        :no-data-text-data.sync="noDataText"
        @on-infinite="onInfinite"
        @on-refresh="onRefresh"
        class="my_scroller"
        ref="my_scroller"
      >
        <ul>
          <li v-for="(item, index) of list" :key="index" :style="lisStyle">
            <div class="footprint">
              <p
                v-if="!list[index - 1]"
                class="p"
                :style="{ 'margin-left': editor ? '0.18rem' : '0' }"
              >
                {{ item.type }}
              </p>
              <p
                v-else-if="list[index - 1].type != list[index].type"
                class="p"
                :style="{ 'margin-left': editor ? '0.18rem' : '0' }"
              >
                {{ item.type }}
              </p>
              <div
                class="liContent"
                :style="{ 'margin-left': editor ? '-0.1rem' : '0' }"
              >
                <b class="check" v-if="editor">
                  <input
                    :id="'checkbox' + index"
                    @click="check(index)"
                    type="checkbox"
                    v-model="checkbox"
                    :value="index"
                    :checked="item.isChecked"
                  />
                  <label :for="'checkbox' + index">
                    <i :class="{ on: item.isChecked }"></i>
                  </label>
                </b>
                <div
                  class="content pro_item"
                  @click="proDetail(item)"
                  ref="content"
                >
                  <div class="img flex-s">
                    <img v-lazy="item.img_path" />
                    <img
                      src="/static/images/shouqing.png"
                      class="soldout"
                      v-if="item.islimit == 2"
                    />
                    <img
                      src="../../assets/images/soldout.png"
                      class="soldout"
                      v-else-if="item.issale == 0"
                    />
                  </div>
                  <div class="detail">
                    <p>
                      {{ item.name }}
                    </p>
                    <!--                  <b>已售{{parseFloat(item.sales_num) / 10000 >= 1 ? (parseInt(parseInt(item.sales_num) / 100) / 100).toFixed(2) + 'w' : item.sales_num}}</b>-->
                    <span class="nowPrice" v-if="!item.sales_price">
                      <sub>¥</sub>
                      <i>0</i>
                      <sup>.00</sup>
                    </span>
                    <span class="nowPrice" v-if="item.sales_price">
                      <sub>¥</sub>
                      <i>{{
                        String(parseFloat(item.sales_price).toFixed(2)).slice(
                          0,
                          String(
                            parseFloat(item.sales_price).toFixed(2)
                          ).indexOf('.')
                        )
                      }}</i>
                      <sup>{{
                        String(parseFloat(item.sales_price).toFixed(2)).slice(
                          String(
                            parseFloat(item.sales_price).toFixed(2)
                          ).indexOf('.'),
                          String(parseFloat(item.sales_price).toFixed(2)).length
                        )
                      }}</sup>
                    </span>
                  </div>
                  <div
                    class="opensku"
                    v-if="item.islimit != 2 && item.issale != 0"
                    @click.stop="openSku(item, index)"
                  >
                    <img src="/static/images/index/cart.png" />
                  </div>
                </div>
                <!--              <p ref="p" @click="deleteClick($event, item, index)">删除</p>-->
              </div>
            </div>
          </li>
        </ul>
      </Scroller>
      <!--</scroller>-->
      <footer v-if="editor">
        <b class="check">
          <input
            id="'checkboxAll"
            @click="checkAllClick"
            type="checkbox"
            v-model="checkboxAll"
            value="all"
            :checked="checkedAll"
          />
          <label for="'checkboxAll">
            <i :class="{ on: checkedAll }"></i>
            <div>全选</div>
          </label>
          <div class="clear"></div>
        </b>
        <button class="btnDel" v-if="!deleteBool">删除</button>
        <button class="btnDel delete" v-else @click="deleteClick()">
          删除
        </button>
      </footer>
    </div>
    <div
      ref="empty"
      class="empty"
      v-if="
        list && list.length <= 0 && (productlist && productlist.length <= 0)
      "
      style="display: none;height: 100%;"
    >
      <empty :path="'noFootprint'"></empty>
    </div>
    <div
      ref="empty"
      class="empty"
      v-if="list && list.length <= 0 && (productlist && productlist.length > 0)"
      style="display: none"
    >
      <img src="../../assets/images/nosearch.png" />
      <p>暂无商品浏览记录~</p>
    </div>
    <div
      ref="recommend"
      v-if="list && list.length <= 0 && (productlist && productlist.length > 0)"
      style="padding: 0.15rem 0.11rem 0.11rem;background: #fff;display: none"
    >
      <product-list :title="title" :productlist="productlist"></product-list>
    </div>
    <van-sku
      close-on-click-overlay
      hide-quota-text
      v-model="showsku"
      :sku="sku"
      :goods="goods"
      :quota-used="quotaUsed"
      :goods-id="productId"
      :quota="quota"
      :hide-stock="sku.hide_stock"
      :custom-stepper-config="customStepperConfig"
      class="good_sku"
      ref="sku"
      @sku-selected="checkedSku"
      :initial-sku="initialSku"
    >
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.picture" />
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-name">{{ goods.title }}</div>
            <div class="van-sku-header-item">
              {{ skuname == '' ? '请选择商品规格' : '已选 ' + skuname }}
            </div>
            <div class="van-sku__goods-price">
              <span class="van-sku__price-symbol">¥</span
              ><span class="van-sku__price-num">{{ skuprice }}</span>
              <span class="van-sku__costprice-symbol">¥</span
              ><span class="van-sku__costprice-num">{{ skucostprice }}</span>
            </div>
            <!--<i class="van-icon van-icon-clear van-sku__close-icon" @click="showsku = false"></i>-->
          </div>
        </div>
      </template>

      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <van-button
            square
            size="large"
            type="danger"
            class="sure yellow"
            :class="{ sureGray: sureGray }"
            @click="onConfirmClicked(0)"
          >
            加入购物车
          </van-button>
          <van-button
            square
            size="large"
            type="danger"
            class="sure"
            :class="{ sureGray: sureGray }"
            @click="onConfirmClicked(1)"
          >
            立即购买
          </van-button>
        </div>
      </template>
    </van-sku>
  </div>
</template>

<script>
import productList from '../common/productList'
import empty from '../emptypage/empty'
import Scroller from '../common/Scroller'
import {
  isWeixin,
  fenxiang,
  dateFn,
  isApp,
  exclusiveidFn,
  pointParams
} from '../../assets/common/js/config'
import wx from 'weixin-js-sdk'
import { Sku } from 'vant'

export default {
  name: 'collection',
  data() {
    return {
      list: [],
      productlist: [],
      title: '为你推荐',
      checkbox: [],
      empty: false, // 判断header DOM元素是否显示
      isChooseProduct: [],
      editor: false,
      checkedAll: false,
      checkboxAll: [],
      deleteBool: false,
      lisStyle: {},
      x: null,
      p: null,
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      daiIndex: 0,
      zcIndex: 0,
      sureGray: false,
      skuprice: '197.00-218.90',
      skucostprice: '',
      skuId: null, // 总规格id 注： 传给后端的参数
      itemnum: null, // 购买数量 注：传给后端的参数
      i: 0,
      productId: null,
      showsku: false,
      skuname: '',
      quota: 0,
      quotaUsed: 0,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 227,
        collection_id: 2261,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '测试商品',
        picture: ''
      },
      listItem: {},
      itemIndex: null,
      initialSku: {},
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {
          const { action, limitType, quota, quotaUsed } = data
          if (action == 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action == 'plus') {
            // let msg = `单次限购${quota}件`;
            // if (quotaUsed > 0) msg += `，你已购买${quotaUsed}`;
            let msg = `数量超出范围~`
            this.$toast(msg)
          }
        },
        handleStepperChange: (currentValue) => {},
        stockNum: 0,
        stockFormatter: (stockNum) => {}
      },
      productNum: 0,
      skuValueToast: null,
      islimit: 0,
      issale: 1,
      buyType: -1
    }
  },
  components: {
    productList,
    empty,
    Scroller,
    [Sku.name]: Sku
  },
  watch: {
    editor(n) {
      console.log(n)
    }
  },
  mounted: function() {
    if (isWeixin()) {
      fenxiang({ path: 'collection' })
    }
    // this.nowPage = 1
    // this.getData()
  },
  destroyed: function() {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter(to, from, next) {
    if (!sessionStorage.askPositon || from.path == '/') {
      // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next((vm) => {
        vm.empty = false
        vm.nowPage = 1
        vm.getData(function() {
          vm.checkAllClick(vm.checkedAll)
          vm.editorClick(false)
        })
      })
    } else {
      next((vm) => {
        vm.empty = false
        vm.nowPage = 1
        vm.getData(function() {
          vm.checkAllClick(vm.checkedAll)
          vm.editorClick(false)
        })
        if (vm && vm.$refs.my_scroller) {
          // 通过vm实例访问this
          setTimeout(function() {
            window.scrollTo(0, sessionStorage.askPositon, false)
          }, 0) // 同步转异步操作
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    sessionStorage.askPositon =
      this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    getData: function(fn) {
      var url =
        this.$ajax.getUserItemTrackRecord_URL +
        '?pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize
      var recommendUrl = this.$ajax.getReCommendItemList_URL
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          if (that.nowPage === 1) {
            that.list = res.data.list
            that.list.map(function(item, index) {
              let itemtime = new Date(item.date).getTime()
              let curtime = new Date(new Date().toLocaleDateString()).getTime()
              if (itemtime == curtime) {
                item.type = '今天'
              } else {
                item.type = dateFn(item.date + ' 00:00:00', 'datestr_md')
              }
            })
            that.refresh = false
          } else {
            let list = res.data.list
            list.map(function(item, index) {
              let itemtime = new Date(item.date).getTime()
              let curtime = new Date(new Date().toLocaleDateString()).getTime()
              if (itemtime == curtime) {
                item.type = '今天'
              } else {
                item.type = dateFn(item.date + ' 00:00:00', 'datestr_md')
              }
            })
            that.list = that.list.concat(list)
          }
          that.loading = false
          if (res.data.list.length < that.pagesize) {
            that.finished = true
            if (that.list && that.list.length <= 0) {
              that.empty = true
              that.$customRequestAjax(recommendUrl).then((res) => {
                if (res.data.code === 200) {
                  if (res.data.itemlist.length > 0) {
                    that.productlist = res.data.itemlist
                    setTimeout(function() {
                      that.$refs.empty.style.display = 'block'
                      that.$refs.recommend.style.display = 'block'
                    })
                  } else {
                    setTimeout(function() {
                      that.$refs.empty.style.display = 'block'
                    })
                  }
                }
              })
            }
          } else {
            that.finished = false
          }
          if (typeof fn === 'function') {
            fn()
          }
        }
      })
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      // this.list = []
      var that = this
      this.getData(function() {
        that.checkAllClick(false)
        that.editorClick(false)
      })
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      // this.editor = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData(function() {
        that.checkAllClick(that.checkedAll)
        // that.editorClick(that.editor)
      })
      // })
    },
    proDetail: function(items) {
      if (!this.editor) {
        var arg = isApp()
        let data = {
          itemid: items.itemid,
          scenepoint: 'FOOTPRINT'
        }
        this.$clickburiedPoint({
          url: 'ckysdatacenter/itemclick/save',
          data: data
        })
        if (arg == '') {
          this.$router.push({
            path: '/productdetail',
            query: {
              itemid: items.itemid
            }
          })
        } else if (arg.indexOf('xcx') < 0) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              type: 'goItemDetail',
              itembaseid: items.itemid
            })
          )
        } else {
          wx.miniProgram.navigateTo({
            url:
              '/pages/product/main?itemid=' +
              items.itemid +
              '&exclusiveid=' +
              exclusiveidFn() +
              pointParams('&')
          })
        }
      }
    },
    check: function(index) {
      // 再设置当前点击项选中
      this.checkbox = this.list[index].name
      // 设置值，以供传递
      this.list[index].isChecked = !this.list[index].isChecked
      var idxAll = 0
      var idxDel = 0
      this.list.forEach((item) => {
        if (!item.isChecked) {
          this.checkedAll = false
          idxDel++
        } else {
          this.deleteBool = true
          idxAll++
        }
      })
      if (idxAll === this.list.length) {
        this.checkedAll = true
      }
      if (idxDel === this.list.length) {
        this.deleteBool = false
      }
      this.isChooseProduct = this.list.filter((item) => item.isChecked === true)
      console.log(this.isChooseProduct)
    },
    editorClick: function(editor) {
      if (typeof editor === 'boolean') {
        this.editor = editor
      } else {
        this.editor = !this.editor
      }
      if (this.editor) {
        this.lisStyle = {
          marginRight: 0
        }
        this.$refs.content.map((item) => (item.style.marginLeft = 0))
      } else {
        this.lisStyle = {
          marginRight: '0.11rem'
        }
      }
    },
    clearClick: function() {
      this.deleteClick('clearAll')
    },
    allCheck: function(check) {
      this.list.forEach(function(item) {
        item.isChecked = check
      })
      this.isChooseProduct = this.list.filter((item) => item.isChecked === true)
      console.log(this.isChooseProduct)
    },
    checkAllClick: function(checkAll) {
      if (typeof checkAll === 'boolean') {
        this.checkedAll = checkAll
      } else {
        this.checkedAll = !this.checkedAll
      }
      if (this.checkedAll) {
        this.allCheck(true)
        this.deleteBool = true
      } else {
        this.allCheck(false)
        this.deleteBool = false
      }
    },
    start: function(e, id) {
      this.x = e.targetTouches[0].pageX
    },
    move: function(e, id) {
      var change = e.targetTouches[0].pageX - this.x
      change = Math.min(Math.max(-100, change), 100)
      e.currentTarget.style.left = change + 'px'
    },
    end: function(e, id) {
      var left = parseInt(e.currentTarget.style.left)
      if (left < -50) {
        if (!this.editor) {
          e.currentTarget.style.marginLeft = '-0.74rem'
          // $(e.currentTarget).find('.item-text').find('span').css('margin-right', '18px').parent().parent().css('margin-right', '60px')
        }
      } else if (left > 50) {
        e.currentTarget.style.marginLeft = 0
      } else {
        e.currentTarget.style.marginLeft = 0
      }
    },
    deleteClick: function(type) {
      var that = this
      var url = this.$ajax.delUserItemTrack_URL
      var deleteProduct = {
        goodparam: [],
        itemIndex: []
      }
      deleteProduct.goodparam = []
      deleteProduct.itemIndex = []
      that.list.map(function(item, index) {
        if (item.isChecked) {
          deleteProduct.goodparam.push({
            date: item.date,
            itemid: item.itemid
          })
          deleteProduct.itemIndex.unshift(index)
        }
      })
      var data = {
        goodparam: JSON.stringify(deleteProduct.goodparam)
      }
      if (type == 'clearAll') data = { goodparam: '' }
      that.$dialog
        .confirm({
          message:
            type == 'clearAll' ? '是否要清除所有浏览记录？' : '删除所选商品？',
          className: 'collect_button_alert collection_button',
          cancelButtonColor: '#FC0324',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: type == 'clearAll' ? '清除' : '删除',
          closeOnPopstate: true
        })
        .then(function() {
          // on confirm
          that.$customRequestAjax.post(url, data).then((res) => {
            if (res.data.code === 200) {
              console.log(that.list)
              deleteProduct.itemIndex.map(function(item, index) {
                that.list.splice(item, 1)
              })
              that.nowPage = 1
              that.list = []
              that.getData(function() {
                that.checkAllClick(false)
                that.editorClick(false)
              })
            }
          })
        })
        .catch(function() {
          // on cancel
        })
    },
    openSku(items, idx) {
      var that = this
      that.daiIndex = 0
      that.zcIndex = 0
      items.sku_rule_list.map(function(item) {
        if (item.issale == 1 && item.canbuycnt > 0) {
          if (item.islimit == 1) {
            // 待售
            that.daiIndex++
          } else if (item.islimit == 0) {
            that.zcIndex++
          }
        }
      })
      if (that.zcIndex <= 0 && that.daiIndex <= 0) {
        this.$toast('当前商品无货')
        return
      }
      this.productNum = items.num
      this.listItem = items
      this.itemIndex = idx
      this.productId = this.listItem.itemid
      this.maxNum = parseInt(this.listItem.canbuycnt)
      this.goods.title = items.name
      this.skuprice = parseFloat(items.sales_price).toFixed(2)
      this.skucostprice = parseFloat(items.cost_price).toFixed(2)
      this.goods.picture = items.img_path
      this.skuname = items.spec ? items.spec : ''
      // console.log('skuValueToast:', that.skuValueToast)
      if (
        !that.skuValueToast ||
        !that.skuValueToast.selectedSkuComb ||
        that.skuValueToast.selectedSkuComb.stock_num <= 0
      ) {
        that.goods.picture = items.img_path
        that.skuname = ''
        that.sureGray = true
        that.i = 0
      }
      var arg = isApp()
      if (!isWeixin()) {
        if (
          that.waptoken.waptoken &&
          that.waptoken.waptoken == that.waptoken.tourists &&
          arg == ''
        ) {
          that.$store.commit(
            'PATH_VALUE',
            JSON.stringify({ itemid: that.$route.query.itemid })
          )
          that.$router.push({
            path: '/login',
            query: {
              routeval: 'productdetail'
            }
          })
        } else {
          that.sku.list = []
          that.sku.tree = []
          items.normlist.map(function(item, index) {
            that.sku.tree.push({
              k: item.spec_classify_name,
              v: [],
              k_s: 's' + (index + 1)
            })
            item.speclist.map(function(itemSon) {
              that.sku.tree[index].v.push({
                id: itemSon.spec_id,
                name: itemSon.spec_name
              })
            })
          })
          items.sku_rule_list.map(function(item) {
            // if (item.issale === 1 && item.islimit === 0) {
            var stockNum =
              item.issale == 0 || item.islimit == 2 || item.is_can_buy == 0
                ? 0
                : parseInt(item.canbuycnt)
            that.sku.list.push({
              id: item.skuid,
              price: item.sales_price,
              s1: item.spec_group_id.split('_')[0],
              s2: item.spec_group_id.split('_')[1],
              s3: item.spec_group_id.split('_')[2],
              payfreight: item.freightrule.payfreight,
              isdiscount: item.isdiscount,
              isfullgift: item.isfullgift,
              ispresale: item.ispresale,
              presaletime: item.presaletime,
              stock_num: stockNum,
              cost_price: item.cost_price
            })
            if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
              if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
                that.skuValueToast.selectedSkuComb.stock_num = stockNum
                if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
                  that.goods.picture = items.img_main_path
                  that.skuname = ''
                  that.sureGray = true
                }
              }
            }
            that.sku.stock_num += stockNum
            if (stockNum > 0) {
              that.skuname = item.sku_name
              that.goods.picture = item.spec_imgpath
              that.goods.isdiscount = item.isdiscount
              that.goods.isfullgift = item.isfullgift
              that.goods.payfreight = item.freightrule.payfreight
              that.goods.ispresale = item.ispresale
              that.goods.presaletime = item.presaletime
              that.initialSku = {
                s1: item.spec_group_id.split('_')[0],
                s2: item.spec_group_id.split('_')[1],
                s3: item.spec_group_id.split('_')[2],
                payfreight: item.freightrule.payfreight,
                isdiscount: item.isdiscount,
                isfullgift: item.isfullgift,
                ispresale: item.ispresale,
                presaletime: item.presaletime,
                selectedNum: 1
              }
            }
            // }
          })
          // console.log('this.skuprice:', that.skuprice)
          this.showsku = true
        }
      } else {
        that.sku.tree = []
        that.sku.list = []
        items.normlist.map(function(item, index) {
          that.sku.tree.push({
            k: item.spec_classify_name,
            v: [],
            k_s: 's' + (index + 1)
          })
          item.speclist.map(function(itemSon) {
            that.sku.tree[index].v.push({
              id: itemSon.spec_id,
              name: itemSon.spec_name
            })
          })
        })
        items.sku_rule_list.map(function(item) {
          // if (item.issale === 1 && item.islimit === 0) {
          var stockNum =
            item.issale == 0 || item.islimit == 2 ? 0 : parseInt(item.canbuycnt)
          that.sku.list.push({
            id: item.skuid,
            price: item.sales_price,
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            payfreight: item.freightrule.payfreight,
            isdiscount: item.isdiscount,
            isfullgift: item.isfullgift,
            ispresale: item.ispresale,
            presaletime: item.presaletime,
            stock_num: stockNum,
            cost_price: item.cost_price
          })
          if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
            if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
              that.skuValueToast.selectedSkuComb.stock_num = stockNum
              if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
                that.goods.picture = items.img_main_path
                that.skuname = ''
                that.sureGray = true
              }
            }
          }
          that.sku.stock_num += stockNum
          if (stockNum > 0 && that.i == 0) {
            that.skuname = item.sku_name
            that.goods.picture = item.spec_imgpath
            that.goods.isdiscount = item.isdiscount
            that.goods.isfullgift = item.isfullgift
            that.goods.payfreight = item.freightrule.payfreight
            that.goods.ispresale = item.ispresale
            that.goods.presaletime = item.presaletime
            that.initialSku = {
              s1: item.spec_group_id.split('_')[0],
              s2: item.spec_group_id.split('_')[1],
              s3: item.spec_group_id.split('_')[2],
              payfreight: item.freightrule.payfreight,
              isdiscount: item.isdiscount,
              isfullgift: item.isfullgift,
              ispresale: item.ispresale,
              presaletime: item.presaletime,
              selectedNum: 1
            }
            that.i = 1
          } else if (stockNum <= 0 && that.i == 0) {
            that.skuprice = parseFloat(items.sales_price).toFixed(2)
            that.skucostprice = parseFloat(items.cost_price).toFixed(2)
            // if (parseFloat(items.sales_top_price) != parseFloat(items.sales_bottom_price)) {
            //   that.skuprice = parseFloat(items.sales_bottom_price).toFixed(2) + '-' + parseFloat(items.sales_top_price).toFixed(2)
            // } else {
            //   that.skuprice = parseFloat(items.sales_bottom_price).toFixed(2)
            // }
            // that.initialSku = {}
            that.i = 1
          }
          // }
        })
        this.showsku = true
      }
    },
    checkedSku(skuValue) {
      if (!skuValue.selectedSkuComb) {
        this.sureGray = true
      } else {
        this.sureGray = false
      }
      this.skuValueToast = skuValue
      console.log(skuValue.selectedSkuComb)
      if (skuValue.selectedSkuComb) {
        this.customStepperConfig.stockNum = this.quota =
          skuValue.selectedSkuComb.stock_num
      } else {
        this.customStepperConfig.stockNum = this.quota = 0
      }
      var skuStr = ''
      this.skuname = ''
      var len = this.listItem.sku_rule_list
      var skuIndex = 0
      var index = 0
      this.goods.isdiscount = 0
      this.goods.isfullgift = 0
      this.goods.payfreight = 0
      this.goods.ispresale = 0
      this.goods.presaletime = ''
      Object.keys(skuValue.selectedSku).forEach(function(key) {
        skuIndex++
        if (skuValue.selectedSku[key] != '') {
          skuStr =
            skuStr == ''
              ? skuValue.selectedSku[key]
              : skuStr + '_' + skuValue.selectedSku[key]
          index++
        }
      })
      if (index == skuIndex) {
        for (var i = 0; i < len.length; i++) {
          if (len[i].spec_group_id == skuStr) {
            this.skuname = len[i].sku_name
            this.goods.picture = len[i].spec_imgpath
            this.goods.isdiscount = len[i].isdiscount
            this.goods.isfullgift = len[i].isfullgift
            this.goods.payfreight = len[i].freightrule.payfreight
            this.goods.ispresale = len[i].ispresale
            this.goods.presaletime = len[i].presaletime
            if (skuValue.selectedSkuComb !== null) {
              this.skuprice = parseFloat(
                skuValue.selectedSkuComb.price
              ).toFixed(2)
              this.skucostprice = parseFloat(
                skuValue.selectedSkuComb.cost_price
              ).toFixed(2)
            }
            break
          }
        }
      } else {
        this.skuprice = parseFloat(this.listItem.sales_price).toFixed(2)
        this.skucostprice = parseFloat(this.listItem.cost_price).toFixed(2)
        // if (this.listItem.sales_low_price != this.listItem.sales_high_price) {
        //   this.skuprice = parseFloat(this.listItem.sales_low_price).toFixed(2) + '-' + parseFloat(this.listItem.sales_high_price).toFixed(2)
        // } else {
        //   this.skuprice = parseFloat(this.listItem.sales_low_price).toFixed(2)
        // }
      }
      console.log(skuValue, 'that.initialSku', this.initialSku)
    },
    onConfirmClicked(type) {
      this.buyType = type
      if (this.sureGray) {
        return
      }

      // 1立即购买，0加入购物车
      let dataType = this.buyType == 1 ? 'buyNow' : 'addToCart'
      this.dataCollection(dataType)
      var skuData = this.$refs.sku.getSkuData()
      var that = this
      if (skuData.selectedSkuComb !== null) {
        that.showsku = false
        that.skuId = skuData.selectedSkuComb.id
        if (skuData.selectedNum == 0) {
          skuData.selectedNum = 1
        }
        that.itemnum = skuData.selectedNum
        var urlCheck =
          that.$ajax.checkOrder_URL +
          '?skuids=' +
          that.skuId +
          '&buynum=' +
          that.itemnum
        var urlShop = that.$ajax.addShoppingCart_URL
        var data = {
          skuid: that.skuId,
          itemnum: that.itemnum
        }
        if (!that.buyType) {
          console.log(data)
          that.$customRequestAjax.post(urlShop, data).then((res) => {
            if (res.data.code === 200) {
              that.$store.commit('ADD_CART_INIT_DATA', 1)
              that.$commonburiedPoint({
                data: {
                  isaddcart: 1,
                  itemid: that.skuId,
                  skuid: that.skuId
                }
              })
              that.$toast('已成功加入购物车')
              if (that.$route.path == '/cart') {
                that.$emit('addCartHandler')
              }
            }
          })
        } else {
          that.$customRequestAjax(urlCheck).then((res) => {
            if (res.data.code === 200) {
              let currentdiscount =
                skuData.selectedSkuComb.isdiscount == 1
                  ? that.currentdiscount
                  : 1
              var shopConfirmResult = {
                skuidArr: [],
                from: 2,
                orderfrom: 1,
                liveId: that.listItem.liveid ? [that.listItem.liveid] : [],
                itemNum: [],
                totalmoney:
                  parseFloat(skuData.selectedSkuComb.price) *
                  skuData.selectedNum *
                  currentdiscount,
                totalnum: skuData.selectedNum
              }
              shopConfirmResult.skuidArr.push(that.skuId)
              shopConfirmResult.itemNum.push(that.itemnum)
              localStorage.setItem(
                'shopConfirmResult',
                JSON.stringify(shopConfirmResult)
              )
              sessionStorage.removeItem('choose_integral')
              sessionStorage.removeItem('choose_coupon')
              sessionStorage.removeItem('choose_product')
              sessionStorage.removeItem('oversea_List')
              var arg = isApp()
              if (arg == '') {
                that.$router.push('/order')
              } else if (arg != '' && arg.indexOf('xcx') < 0) {
                var obj = {
                  type: 'addToConfirmOrder',
                  skuids: shopConfirmResult.skuidArr.join(),
                  item_num: shopConfirmResult.itemNum.join(),
                  from: shopConfirmResult.from
                }
                that.$commonburiedPoint({
                  data: {
                    scenepoint: window.document.title,
                    scenedesc: window.location.href,
                    url: 'order-confirm'
                  },
                  rnType: 'addToConfirmOrder',
                  callback: () => {
                    window.ReactNativeWebView.postMessage(JSON.stringify(obj))
                  }
                })
              } else {
                shopConfirmResult.orderHadOnShow = 0
                shopConfirmResult.isInitData = 1
                shopConfirmResult.live_id = ''
                shopConfirmResult.type = 'addToConfirmOrder'
                wx.miniProgram.navigateTo({
                  url:
                    '/pages/order/main?shopConfirmResult=' +
                    JSON.stringify(shopConfirmResult) +
                    '&scenepoint=' +
                    encodeURIComponent(window.document.title) +
                    '&exclusiveid=' +
                    exclusiveidFn() +
                    pointParams('&')
                })
              }
            }
          })
        }
      }
    },
    // 埋点
    dataCollection(dataType) {
      let params = {
        productId_var: this.listItem.itemid,
        productName_var: this.listItem.name,
        firstCat_var: this.listItem.brand,
        productType_var: '',
        productFormat_var: this.skuId
      }
      console.log(dataType, params)
      gio('track', dataType, params)
    }
  }
}
</script>

<style scoped lang="scss">
.collect {
  header {
    height: 0.38rem;
    background: #fff;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 10;
    p {
      float: right;
      font-size: 0.13rem;
      color: #191818;
      padding: 0.1rem 0.11rem;
    }
  }
  .my_scroller {
    padding-top: 0.38rem;
    padding-bottom: 0.44rem;
  }
  ul {
    background: #ffffff;
    border-radius: 0.04rem;
    padding: 0 0.1rem 0.11rem 0.15rem;
    margin: 0.1rem 0;
    .check {
      width: 0.31rem;
      input {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
      }
      label {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
      }
    }
    li {
      display: flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: -webkit-flex;
      margin: 0 0.11rem 0;
    }
    .footprint {
      width: 100%;
      > .p {
        font-size: 0.18rem;
        color: #222222;
        line-height: 0.25rem;
        padding-bottom: 0.11rem;
        border-bottom: 0.01rem solid #d8d8d8;
        padding-top: 0.11rem;
        margin-bottom: 0.1rem;
      }
    }
    .liContent {
      /*flex-shrink: 0;*/
      display: flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: -webkit-flex;
      background: #fff;
      border-radius: 0.04rem;
      overflow: hidden;
      width: 100%;
      > p {
        font-size: 0.14rem;
        color: #ffffff;
        width: 0.74rem;
        margin-right: -0.74rem;
        flex-shrink: 0;
        background: linear-gradient(
          90deg,
          rgba(252, 3, 36, 1) 0%,
          rgba(255, 20, 79, 1) 100%
        );
        background: -webkit-linear-gradient(
          90deg,
          rgba(252, 3, 36, 1) 0%,
          rgba(255, 20, 79, 1) 100%
        );
        background: -moz-linear-gradient(
          90deg,
          rgba(252, 3, 36, 1) 0%,
          rgba(255, 20, 79, 1) 100%
        );
        background: -ms-linear-gradient(
          90deg,
          rgba(252, 3, 36, 1) 0%,
          rgba(255, 20, 79, 1) 100%
        );
        background: -o-linear-gradient(
          90deg,
          rgba(252, 3, 36, 1) 0%,
          rgba(255, 20, 79, 1) 100%
        );
        border-radius: 0px 4px 4px 0px;
        text-align: center;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        justify-content: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        -o-justify-content: center;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
      }
      .content {
        padding: 0 0 0.1rem;
        display: flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: -webkit-flex;
        width: 100%;
        position: relative;
        .img {
          width: 0.6rem;
          height: 0.6rem;
          position: relative;
          img {
            width: 100%;
            height: 100%;
            position: absolute;
            /*height: 100%;*/
          }
          .soldout {
            width: 59%;
            height: 59%;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
          }
        }
        .detail {
          margin-left: 0.07rem;
          padding-top: 0.04rem;
          position: relative;
          min-width: 50%;
          p {
            /*height: 0.36rem;*/
            color: #292929;
            font-size: 0.13rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          b {
            font-weight: 400;
            display: block;
            margin-top: 0.05rem;
            margin-bottom: 0.04rem;
            font-size: 0.11rem;
            color: #6c6c6c;
          }
          .nowPrice {
            font-size: 0;
            display: block;
            color: #fc0324;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            & sub {
              font-size: 0.12rem;
              font-weight: 400;
              vertical-align: baseline;
            }
            i {
              font-size: 0.14rem;
              font-style: normal;
              font-weight: 700;
            }
            & sup {
              font-size: 0.12rem;
              font-weight: 700;
              vertical-align: baseline;
            }
          }
        }
        .opensku {
          width: 0.19rem;
          height: 0.19rem;
          position: absolute;
          right: 0;
          bottom: 0.1rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .check {
    font-weight: 400;
    position: relative;
    i {
      display: block;
      width: 0.2rem;
      height: 0.2rem;
      /*float: left;*/
      margin-right: 0.05rem;
      background: url(../../assets/images/uncheck.png) no-repeat left top;
      background-size: 100% 100%;
    }
    input {
      display: block;
      float: left;
      position: absolute;
      width: 0.2rem;
      height: 0.2rem;
      left: 0;
      outline: none;
      -webkit-appearance: none;
      opacity: 0;
    }
    .on {
      background: url(../../assets/images/check.png) no-repeat left top;
      background-size: 100% 100%;
    }
    label {
      float: left;
      font-size: 0.12rem;
      color: #444;
      height: 0.2rem;
      display: flex;
      align-items: center;
    }
  }
  footer {
    height: 0.49rem;
    box-shadow: 0 -0.01rem 0 0 rgba(0, 0, 0, 0.25);
    -webkit-box-shadow: 0 -0.01rem 0 0 rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0 -0.01rem 0 0 rgba(0, 0, 0, 0.25);
    -ms-box-shadow: 0 -0.01rem 0 0 rgba(0, 0, 0, 0.25);
    -o-box-shadow: 0 -0.01rem 0 0 rgba(0, 0, 0, 0.25);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding-left: 0.11rem;
    padding-right: 0.11rem;
    display: flex;
    display: -webkit-flex;
    display: -o-flex;
    display: -ms-flex;
    display: -moz-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -o-justify-content: space-between;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    background: #fff;
    .clear {
      clear: both;
    }
    input {
      top: 0.06rem !important;
    }
    label {
      /*margin: 0.04rem 0 0.13rem 0 !important;*/
    }
    .btnDel {
      width: 1.1rem;
      height: 0.38rem;
      border-radius: 0.19rem;
      border: 1px solid #e3e3e3;
      font-size: 0.16rem;
      font-weight: 400;
      color: #ffffff;
      background: #e3e3e3;
      outline: none;
      &.delete {
        background: linear-gradient(
          90deg,
          rgba(252, 3, 36, 1) 0%,
          rgba(255, 20, 79, 1) 100%
        );
        background: -webkit-linear-gradient(
          90deg,
          rgba(252, 3, 36, 1) 0%,
          rgba(255, 20, 79, 1) 100%
        );
        background: -moz-linear-gradient(
          90deg,
          rgba(252, 3, 36, 1) 0%,
          rgba(255, 20, 79, 1) 100%
        );
        background: -ms-linear-gradient(
          90deg,
          rgba(252, 3, 36, 1) 0%,
          rgba(255, 20, 79, 1) 100%
        );
        background: -o-linear-gradient(
          90deg,
          rgba(252, 3, 36, 1) 0%,
          rgba(255, 20, 79, 1) 100%
        );
        color: #ffffff;
        border: none;
      }
    }
  }
}
.empty {
  background: #fff;
  padding: 0.4rem 0 0.3rem;
  margin-bottom: 0.1rem;
  img {
    width: 0.88rem;
    height: 0.88rem;
    margin: 0 auto 0.15rem;
  }
  p {
    font-size: 0.13rem;
    font-weight: 400;
    color: rgba(41, 41, 41, 1);
    line-height: 0.18rem;
    text-align: center;
  }
}
</style>
<style lang="scss">
.collection_button {
  border-radius: 0.04rem;
  .van-dialog__content {
    .van-dialog__message {
      color: #444444;
    }
  }
}
.footprint {
  .good_sku {
    .van-icon-cross {
      background: url('../../assets/images/close3.png') no-repeat center;
      background-size: 100%;
      color: transparent;
    }
  }
  .van-button--danger.sure {
    background: linear-gradient(90deg, #f63a66 0%, #fc0324 100%);
  }
  .van-button--danger.yellow {
    background: linear-gradient(90deg, #ffa700 0%, #ffba00 100%);
  }
}
.footprint {
  .good_sku .van-sku-row__item {
    border-radius: 0.15rem;
    font-size: 0.13rem;
    color: #5e5e5e;
    padding: 0 0.1rem;
    border: solid 1px transparent;
  }
  .good_sku .van-sku-row__item::before {
    background: #eeeff4;
  }
  .good_sku .van-sku__goods-price {
    margin-top: 0.2rem;
  }
  .good_sku .van-sku__price-symbol,
  .van-sku__price-num {
    font-size: 0.16rem;
    color: #fc0324;
    font-weight: 600;
  }
  .good_sku .van-sku__costprice-symbol {
    margin-left: 0.05rem;
  }
  .good_sku .van-sku__costprice-symbol,
  .van-sku__costprice-num {
    font-size: 0.12rem;
    color: #979797;
    font-weight: normal;
    line-height: 0.2rem;
    text-decoration: line-through;
  }
  .good_sku .van-sku-row__item--active {
    border: solid 1px #fc0324;
    background-color: #fcedeb;
    color: #fc0324;
  }
  .good_sku .van-sku-row__item-name {
    padding: 0.06rem;
  }
  .good_sku .van-sku-row__item-img {
    width: 0.2rem;
    height: 0.2rem;
  }
  .good_sku.van-popup--bottom.van-popup--round {
    border-radius: 0;
    padding-bottom: 0.6rem;
  }
  .good_sku .van-sku-row__title,
  .van-sku__stepper-title {
    padding-bottom: 0.13rem;
    font-size: 0.13rem;
    color: #333333;
    line-height: 0.18rem;
    font-weight: 600;
  }
  .good_sku .van-sku__stepper {
    border-radius: 0.13rem;
    overflow: hidden;
  }
  .good_sku .van-stepper__minus,
  .van-stepper__plus,
  .van-stepper__input {
    height: 0.22rem;
  }
  .good_sku .van-stepper__minus::before,
  .van-stepper__plus::before {
    width: 9px;
  }
  .good_sku .van-stepper__minus::after,
  .van-stepper__plus::after {
    height: 9px;
  }
  .good_sku .van-sku-row__item--disabled {
    background: #fcfcfc;
    border-radius: 0.15rem;
    border: 1px solid #eeeff4;
    color: #dedede;
    &:before {
      background: #fcfcfc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/footprint.vue